import { Variavel } from './../../shared/model/variavel/variavel.model';
import {Component, ElementRef, inject, OnInit} from '@angular/core';
import {ButtonPadraoComponent} from '../../shared/components/button-padrao/button-padrao.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {SlideTogglePadraoComponent} from '../../shared/components/slide-toggle-padrao/slide-toggle-padrao.component';
import {FormFieldComponent} from '../../shared/components/form-field/form-field.component';
import {SelectOneComponent} from '../../shared/components/select-one/select-one.component';
import {TipoVariavel} from '../../shared/enum/tipo-variavel.enum';
import { FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import {ValidacaoAlteracaoCampoService} from '../../shared/service/utilitarios/validacao-alteracao-campo.service';

@Component({
  selector: 'app-modal-cadastro-visualizacao-variavel',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SlideTogglePadraoComponent,
    FormFieldComponent,
    SelectOneComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './modal-cadastro-visualizacao-variavel.component.html',
  styleUrl: './modal-cadastro-visualizacao-variavel.component.css'
})

export class ModalCadastroVisualizacaoVariavelComponent implements OnInit {
  visualizar = false;
  variavel: Variavel = new Variavel();

  tipos: { value: string, label: string }[] = Object.entries(TipoVariavel).map(([key, value]) => ({
    value: key,
    label: value
  }));
  trocadoVariavel = false;

  formVariavel!: FormGroup;

  private readonly dialog = inject(MatDialogRef<ModalCadastroVisualizacaoVariavelComponent>);
  private readonly matDialog = inject(MatDialog);
  private readonly elementRef = inject(ElementRef);
  public data = inject<any>(MAT_DIALOG_DATA);
  public alteracaoService = inject(ValidacaoAlteracaoCampoService);
  private readonly fb = inject(FormBuilder);

  constructor() {
    this.formVariavel = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      tipo: ['', [Validators.required]],
      minCaracteres: ['', [Validators.required, Validators.min(1)]],
      maxCaracteres: ['', [Validators.required, Validators.min(1)]],
    }, { validators: this.customValidatorGroup() });
  }

  ngOnInit() {
    this.visualizar = this.data['visualizar'];
    this.variavel = this.data['variavel'] ?? new Variavel();

    if(!this.visualizar) {
      this.configurarVariavel();
    }

    this.alteracaoService.camposNaoAlterados();
  }

  private configurarVariavel(){
    this.formVariavel.get('nome')?.patchValue(this.variavel.nome);
    this.formVariavel.get('tipo')?.patchValue(this.variavel.tipo);
    this.formVariavel.get('minCaracteres')?.patchValue(this.variavel.minCaracteres);
    this.formVariavel.get('maxCaracteres')?.patchValue(this.variavel.maxCaracteres);
  }

  salvar() {
    const formValue = this.formVariavel.value;
    this.variavel.nome = formValue.nome;
    this.variavel.tipo = formValue.tipo?.value ? formValue.tipo.value : formValue.tipo;
    this.variavel.minCaracteres = formValue.minCaracteres;
    this.variavel.maxCaracteres = formValue.maxCaracteres;
    this.dialog.close(this.variavel);
  }

  cancelar() {
    this.dialog.close();
  }

  getLabel(key: string): string {
    return TipoVariavel[key as keyof typeof TipoVariavel];
  }

  // tipoSelecionado() {
  //   if (!this.variavel.tipo) return null;
  //   let tipo = this.tipos.find(t => t.value === this.variavel.tipo || t.value === this.variavel?.tipo['value']);
  //   return tipo
  // }

  customValidatorGroup() {
    return (form: FormGroup): ValidationErrors | null => {
      const minCtrl = form.get('minCaracteres');
      const maxCtrl = form.get('maxCaracteres');

      if (!minCtrl || !maxCtrl) return null;
      const min = +minCtrl.value;
      const max = +maxCtrl.value;
      if (minCtrl.errors || maxCtrl.errors) return null;
      if (min && max && max < min) {
        maxCtrl.setErrors({ ...(maxCtrl.errors || {}), maxMenorQueMin: true });
      } else {
        if (maxCtrl.errors?.['maxMenorQueMin']) {
          const errosAtuais = (typeof maxCtrl.errors === 'object' && maxCtrl.errors as { maxMenorQueMin?: boolean }) || {};
          const rest = Object.fromEntries(Object.entries(errosAtuais).filter(([chave]) => chave !== 'maxMenorQueMin'));
          maxCtrl.setErrors(Object.keys(rest).length ? rest : null);
        }
      }

      return null;
    };
  }



}
